import { OneUpdateCommentDocument } from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { handleResult } from 'modules/core/lib/handleMutation'
import { OneCreateAction, OneCreationActionResolver } from 'modules/core/lib/oneCreateActions/types'
import { POSTS_POLICIES } from 'modules/posts/lib/postsPolicies'

const useUpdateCommentActionResolver: OneCreationActionResolver = () => {
  const { navigation } = useNavigation()

  const [updateComment, { loading }] = useMutation(OneUpdateCommentDocument, {
    extractorFn: (data) => data.postsMutations.updatePostsComment,
    errorPolicy: 'all',
  })

  const updateCommentHandler = async (args: {
    id: string
    postId: string
    text: string
    mentionedAccessIds?: string[]
  }) => {
    const result = await updateComment({
      variables: {
        id: args.id,
        postId: args.postId,
        text: args.text,
        mentionedAccessIds: args.mentionedAccessIds ?? undefined,
      },
    })

    const handled = handleResult(result, (_errors) => {})

    if (handled.success && handled.data.comment?.postId) {
      return {
        to: navigation.communities.post.id.fullPath({ id: handled.data.comment.postId }),
        data: args,
      }
    }

    return handled
  }

  return {
    resolver: updateCommentHandler,
    loading,
  }
}

export const UpdateCommentAction: OneCreateAction = {
  actionResolver: useUpdateCommentActionResolver,
  policies: [POSTS_POLICIES.groupCanPostSomewhere],
}
